import { SITE_TUNING } from "./siteTuning";

export const getLobbyMovementStepPx = (deltaSeconds: number, isSpeedBoosted: boolean): number =>
    SITE_TUNING.lobby.movement.playerSpeedPxPerSecond *
    (isSpeedBoosted ? SITE_TUNING.lobby.feedback.highFiveSpeedBoostMultiplier : 1) *
    deltaSeconds;

/** Local impulse uses movement intent, never server reconciliation or camera motion. */
export class LobbyLaunch {
    private direction = { x: 0, y: 0 };
    private movedAt = Number.NEGATIVE_INFINITY;
    private impulse = { x: 0, y: 0 };
    private remainingMs = 0;

    get active() {
        return this.remainingMs > 0;
    }

    remember(x: number, y: number, now: number) {
        const length = Math.hypot(x, y);
        if (!length) return;
        this.direction = { x: x / length, y: y / length };
        this.movedAt = now;
    }

    launch(now: number, random = Math.random) {
        // A chained contact refreshes the current trajectory instead of randomizing it.
        if (!this.active) {
            const angle = random() * Math.PI * 2;
            this.impulse = now - this.movedAt <= SITE_TUNING.lobby.feedback.highFiveDirectionMemoryMs
                ? { ...this.direction } : { x: Math.cos(angle), y: Math.sin(angle) };
        }
        this.remainingMs = SITE_TUNING.lobby.feedback.highFiveLaunchDurationMs;
    }

    step(deltaSeconds: number) {
        const duration = SITE_TUNING.lobby.feedback.highFiveLaunchDurationMs;
        const before = this.remainingMs;
        this.remainingMs = Math.max(0, before - deltaSeconds * 1000);
        const distance = SITE_TUNING.lobby.feedback.highFiveLaunchSpeedPxPerSecond *
            (before * before - this.remainingMs * this.remainingMs) / (2 * duration * 1000);
        return { x: this.impulse.x * distance, y: this.impulse.y * distance };
    }

    reset() {
        this.remainingMs = 0;
        this.movedAt = Number.NEGATIVE_INFINITY;
    }
}
